// actions.js
import {
  FETCH_FEEDBACKS_REQUEST,
  FETCH_FEEDBACKS_SUCCESS,
  FETCH_FEEDBACKS_FAILURE,
} from './actionTypes'

// Action for initiating feedback fetch request
export const fetchFeedbacksRequest = () => ({ type: FETCH_FEEDBACKS_REQUEST })

// Action for successfully fetching feedbacks
export const fetchFeedbacksSuccess = (feedbacks) => ({
  type: FETCH_FEEDBACKS_SUCCESS,
  payload: feedbacks,
})

// Action for failing to fetch feedbacks
export const fetchFeedbacksFailure = (error) => ({
  type: FETCH_FEEDBACKS_FAILURE,
  payload: error,
})
